/* eslint-disable */
import React, { FC } from 'react';

interface INotFound {
  className: string;
}
const NotFound: FC<INotFound> = (props) => (
    <svg
    {...props}
    width="592"
    height="421"
    viewBox="0 0 592 421"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2_31)">
      <path
        d="M481.91 274.158L472.715 247.185L457.361 252.416L426 160.396L391.037 172.308L391.142 172.621L379.865 221.299L363.82 290.549L373.18 311.215L406.194 299.965L418.212 295.868L431.591 291.307L442.514 323.365L477.478 311.453L466.554 279.395L481.91 274.158ZM418.336 265.717L410.405 268.42L395.216 273.597L405.583 222.124L406.558 217.853L422.396 264.332L418.336 265.717Z"
        fill="#9DC2E7"
      />
      <path
        opacity="0.25"
        d="M466.554 279.394L477.478 311.452L455.208 301.926L419.615 173.682L406.558 217.854L400.512 242.873L379.866 221.297L391.143 172.62L391.038 172.307L426 160.396L457.36 252.417L472.714 247.185L481.91 274.158L466.554 279.394Z"
        fill="#010101"
      />
      <path
        opacity="0.25"
        d="M418.212 295.867L406.194 299.964L407.96 275.197V270.682L410.405 268.42L411.978 266.967L418.335 265.717C418.336 265.717 417.942 283.909 418.212 295.867Z"
        fill="#010101"
      />
      <path
        d="M418.338 265.716C418.338 265.716 415.334 261.944 410.09 262.38C404.846 262.816 401.92 264.783 401.744 270.245C401.568 275.708 402.871 303.237 401.674 314.162C400.477 325.087 407.925 326.179 408.352 318.095C408.78 310.011 405.615 284.666 407.961 280.515C410.309 276.364 408.88 285.103 411.342 287.944C413.805 290.784 416.426 285.759 413.805 278.986C411.182 272.212 418.338 265.716 418.338 265.716Z"
        fill="url(#paint0_linear_2_31)"
      />
      <path
        d="M98.161 224.93C97.263 224.93 96.598 224.881 96.311 224.761C95.976 224.62 94.954 224.194 86.032 208.268L87.636 207.37C90.968 213.317 96.021 221.973 97.091 223.08C98.062 223.237 103.398 222.865 108.126 222.39L108.311 224.22C105.334 224.518 100.766 224.93 98.161 224.93Z"
        fill="#F26647"
      />
      <path
        d="M130.503 232.653V233.186C130.503 233.186 130.016 243.295 122.448 242.859C122.429 242.859 122.411 242.854 122.392 242.854C117.712 242.551 111.919 240.367 108.035 238.745C105.594 237.724 103.902 236.924 103.714 236.956C103.222 237.034 109.446 262.927 109.363 264.402C109.354 264.6 109.308 264.811 109.239 265.028C108.798 266.43 107.258 268.112 106.334 268.251C106.237 268.265 106.04 268.085 105.76 267.735C102.946 264.237 91.807 243.917 91.503 237.282C91.177 229.991 94.863 225.6 99.861 224.763C103.548 224.147 114.329 225.632 119.73 226.455C121.648 226.749 122.884 226.956 122.884 226.956L130.503 232.653Z"
        fill="#0A2533"
      />
      <path
        opacity="0.25"
        d="M109.364 264.402C109.355 264.6 109.309 264.811 109.24 265.028C108.799 266.43 107.259 268.112 106.335 268.251C106.238 268.265 106.041 268.085 105.761 267.735C109.724 262.14 99.365 234.901 101.618 234.823C102.73 234.786 105.19 236.676 108.036 238.745C105.595 237.724 103.903 236.924 103.715 236.956C103.222 237.034 109.447 262.926 109.364 264.402Z"
        fill="#010101"
      />
      <path
        opacity="0.25"
        d="M130.503 232.653V233.186C130.503 233.186 130.016 243.295 122.448 242.859C123.937 241.669 124.213 239.572 124.102 237.034C123.974 234.096 121.256 229.067 119.73 226.456C121.648 226.75 122.884 226.957 122.884 226.957L130.503 232.653Z"
        fill="#010101"
      />
      <path
        d="M114.398 199.459C114.146 199.855 113.98 200.186 113.98 200.438C113.98 200.438 113.971 200.423 113.953 200.392C113.865 200.236 113.548 199.689 113.14 199.054C112.45 197.988 111.498 196.663 110.923 196.502C109.999 196.249 107.54 199.356 104.216 199.605C103.995 199.625 103.775 199.628 103.549 199.62C99.89 199.454 96.009 194.264 99.126 188.149C100.216 190.388 102.455 190.443 102.455 190.443C102.455 190.443 101.089 190.168 101.039 188.475C105.024 189.183 107.099 186.181 110.542 187.275C113.98 188.364 113.765 190.442 113.765 190.442C113.765 190.442 116.385 189.403 117.203 192.681C117.86 195.303 115.41 197.887 114.398 199.459Z"
        fill="#0A2533"
      />
      <path
        d="M113.953 200.393C113.719 201.22 113.272 202.122 112.67 202.852C111.94 203.745 110.974 204.397 109.884 204.37C107.558 204.315 105.245 201.193 104.216 199.606C107.54 199.358 109.999 196.251 110.923 196.503C111.498 196.664 112.449 197.988 113.14 199.055C113.547 199.69 113.865 200.237 113.953 200.393Z"
        fill="url(#paint1_linear_2_31)"
      />
      <path
        d="M117.313 200.709C117.313 200.709 115.566 204.7 114.909 203.826C114.555 203.353 113.534 203.041 112.67 202.851C113.273 202.121 113.719 201.219 113.953 200.392C113.972 200.423 113.98 200.438 113.98 200.438C113.98 200.185 114.146 199.854 114.398 199.459C115.667 200.416 117.313 200.709 117.313 200.709Z"
        fill="url(#paint2_linear_2_31)"
      />
      <path
        d="M129.602 234.414C126.816 234.005 119.281 225.812 119.281 222.286C119.281 221.789 119.226 221.237 119.134 220.636C118.555 216.967 116.436 211.588 115.553 207.786C114.528 203.363 116.003 201.708 116.003 201.708C119.433 195.81 127.195 207.501 131.622 216.875L131.627 216.88C133.116 220.038 134.101 222.971 134.192 224.935C134.509 231.572 132.388 234.823 129.602 234.414Z"
        fill="#5462AD"
      />
      <path
        opacity="0.25"
        d="M129.602 234.414C126.816 234.005 119.281 225.812 119.281 222.286C119.281 221.789 119.226 221.237 119.134 220.636L119.116 219.064L121.846 204.756C121.846 204.756 125.616 209.239 126.218 217.266C126.816 225.293 135.654 227.04 131.626 216.88C133.115 220.038 134.1 222.971 134.191 224.935C134.509 231.572 132.388 234.823 129.602 234.414Z"
        fill="#010101"
      />
      <path
        d="M123.758 216.718C123.685 216.781 123.556 216.832 123.386 216.879C122.094 217.236 118.329 217.182 116.761 216.874C116.527 216.828 116.338 216.773 116.219 216.718C115.185 216.226 116.219 215.022 115.893 212.893C115.566 210.76 114.747 204.535 117.915 202.622C121.229 200.622 123.647 208.193 123.758 211.964C123.869 215.735 124.471 216.116 123.758 216.718Z"
        fill="#5462AD"
      />
      <path
        d="M123.386 216.879C123.386 216.879 123.235 226.087 121.478 230.432C121.478 230.437 121.478 230.437 121.478 230.441C120.931 231.793 120.228 232.671 119.322 232.653C115.511 232.57 106.951 223.518 106.17 223.187C105.393 222.86 101.499 223.435 101.623 222.86C101.747 222.286 103.264 221.016 104.9 220.405C106.542 219.79 106.252 220.157 116.78 224.994C116.637 224.065 116.697 220.047 116.743 217.771C116.748 217.426 116.758 217.123 116.762 216.875C118.33 217.182 122.094 217.237 123.386 216.879Z"
        fill="url(#paint3_linear_2_31)"
      />
      <path
        d="M112.504 270.627C112.771 272.268 101.746 283.49 102.32 280.543C102.89 277.592 106.334 268.25 106.334 268.25C107.258 268.111 108.798 266.43 109.239 265.027C110.141 266.59 112.279 269.266 112.504 270.627Z"
        fill="#5462AD"
      />
      <path
        opacity="0.25"
        d="M122.448 236.162C122.448 236.162 104.751 232.839 101.255 234.446C97.759 236.052 107.651 264.019 107.651 264.019"
        stroke="white"
        strokeWidth="0.4597"
        strokeMiterlimit="10"
      />
      <path
        opacity="0.25"
        d="M121.478 230.432C121.814 228.583 122.067 223.209 121.138 221.085C120.513 219.65 118.187 218.418 116.742 217.771C116.747 217.426 116.757 217.123 116.761 216.875C118.329 217.183 122.094 217.237 123.386 216.88C123.386 216.879 123.235 226.087 121.478 230.432Z"
        fill="#010101"
      />
      <path
        d="M349.771 278.622L344.502 251.714C340.604 231.812 333.087 217.294 321.952 208.153C310.812 199.018 297.053 196.053 280.672 199.262C264.291 202.471 252.674 210.369 245.828 222.951C238.978 235.539 237.507 251.818 241.419 271.79L246.706 298.8C250.591 318.633 258.099 333.119 269.238 342.254C273.941 346.111 279.118 348.869 284.768 350.521C292.496 352.788 301.112 352.985 310.614 351.127C315.538 350.166 320.035 348.773 324.094 346.952C333.49 342.741 340.579 336.245 345.361 327.455C352.212 314.868 353.679 298.588 349.771 278.622ZM316.881 314.739C315.079 320.257 311.268 323.585 305.447 324.725C299.42 325.906 294.523 324.214 290.745 319.645C288.17 316.532 285.968 311.912 284.142 305.784C284.142 305.779 284.142 305.774 284.142 305.774C284.138 305.765 284.138 305.755 284.133 305.742C283.287 302.901 282.524 299.733 281.843 296.244L274.447 258.468C272.714 248.546 272.709 240.887 274.428 235.489C276.148 230.093 279.954 226.814 285.843 225.665C290.335 224.782 294.21 225.541 297.465 227.932H297.47C298.578 228.75 299.616 229.752 300.582 230.948C304.384 235.651 307.326 243.32 309.404 253.944L316.562 290.498C318.578 301.14 318.684 309.217 316.881 314.739Z"
        fill="#F26647"
      />
      <path
        opacity="0.25"
        d="M319.525 319.787C321.043 322.123 323.06 338.002 324.095 346.953C320.035 348.774 315.538 350.167 310.615 351.128C301.113 352.985 292.497 352.788 284.769 350.522C285.085 349.809 285.375 349.064 285.623 348.301C290.446 333.566 284.419 306.98 284.143 305.784C285.968 311.912 288.17 316.532 290.746 319.645C294.524 324.214 299.421 325.906 305.448 324.725C311.268 323.584 315.08 320.256 316.882 314.739C318.685 309.218 318.578 301.14 316.565 290.497L309.407 253.943C307.329 243.319 304.386 235.65 300.585 230.947C299.619 229.752 298.581 228.75 297.473 227.931C309.1 230.211 318.543 266.209 322.478 283.574C326.408 300.942 326.739 308.974 319.525 319.787Z"
        fill="#010101"
      />
      <path
        d="M286.708 312.847C286.708 312.847 287.462 314.818 291.422 315.91C295.383 317.002 299.097 310.876 301.719 312.847C304.341 314.818 308.537 322.987 312.229 321.743C315.921 320.499 317.013 340.163 315.266 342.348C313.518 344.533 312.261 326.873 307.646 327.401C303.03 327.927 306.526 341.255 303.904 343.659C301.282 346.063 302.375 337.76 299.535 336.23C296.694 334.701 302.594 403.088 298.223 404.18C293.853 405.273 291.013 401.121 292.761 386.483C294.509 371.845 292.323 321.373 289.701 318.751C287.081 316.129 287.245 315.637 286.708 312.847Z"
        fill="#6561AB"
      />
      <path
        d="M285.624 -30.3781V208.195"
        stroke="#0A2533"
        strokeWidth="0.9195"
        strokeMiterlimit="10"
      />
      <path
        d="M342.344 115.938C342.344 115.938 338.863 106.393 339.149 105.655C339.436 104.918 343.26 103.525 343.541 103.934C343.82 104.344 346.237 111.759 345.827 112.291C345.417 112.824 342.344 115.938 342.344 115.938Z"
        fill="#262166"
      />
      <path
        d="M284.417 103.421C284.417 103.421 286.542 104.302 287.487 106.597C288.431 108.891 288.063 100.616 288.063 100.616L287.039 99.674L284.417 103.421Z"
        fill="url(#paint4_linear_2_31)"
      />
      <path
        d="M283.311 103.421C283.311 103.421 285.974 105.408 286.425 105.531C286.875 105.654 287.745 100.451 287.352 99.6319C286.957 98.8119 285.514 97.9929 284.577 98.5259C283.639 99.0589 282.875 103.099 283.311 103.421Z"
        fill="url(#paint5_linear_2_31)"
      />
      <path
        d="M290.399 104.016C290.399 104.016 288.278 99.0999 287.352 98.2399C286.425 97.3799 284.705 98.4859 284.581 98.9359C284.457 99.3859 286.639 99.7139 287.352 100.452C288.064 101.19 286.138 106.638 287.982 108.564C289.825 110.489 290.399 104.016 290.399 104.016Z"
        fill="url(#paint6_linear_2_31)"
      />
      <path
        d="M339.723 117.043C339.723 117.043 341.607 116.019 342.017 115.486C342.426 114.953 341.689 112.946 342.877 111.103C344.065 109.259 346.605 109.792 347.219 112.004C347.834 114.216 346.237 117.002 345.499 117.862C344.761 118.722 339.723 122.327 339.723 122.327"
        fill="url(#paint7_linear_2_31)"
      />
      <path
        d="M341.073 121.317C341.018 121.644 340.682 122.204 340.03 122.968C337.639 125.763 331.051 131.234 319.176 137.487C318.942 138.443 318.758 139.418 318.62 140.392C318.179 143.504 318.187 146.649 318.335 149.476C318.371 150.203 318.417 150.911 318.468 151.591C318.685 154.57 318.979 157.03 318.901 158.455C318.864 159.08 318.754 159.503 318.543 159.691C318.276 159.925 317.995 160.137 317.701 160.326C311.77 164.133 300.975 158.446 299.228 156.735C299.09 156.602 299.007 156.491 298.99 156.413C298.686 155.264 299.863 154.036 300.52 152.068C300.63 151.733 300.741 150.983 300.851 149.958C301.164 146.928 301.435 141.508 301.532 137.43C301.587 134.827 301.573 132.773 301.454 132.23C301.449 132.221 301.449 132.211 301.449 132.211C301.123 130.873 291.178 115.849 288.195 110.525C287.648 109.555 287.336 108.907 287.353 108.723C287.463 107.523 289.757 103.262 290.249 103.317C290.332 103.326 290.636 103.708 291.095 104.342C293.399 107.542 299.596 117.215 300.736 118.447C301.803 119.601 307.232 125.316 309.559 127.766C310.216 128.451 310.625 128.883 310.625 128.883C311.885 128.86 313.148 128.745 314.413 128.548C325.589 126.824 336.572 118.999 339.446 116.824C339.919 116.466 340.173 116.263 340.173 116.263C340.173 116.263 341.321 119.787 341.073 121.317Z"
        fill="#F47920"
      />
      <path
        d="M313.183 133.826C309.371 134.442 309.36 129.482 309.558 127.767C310.215 128.452 310.624 128.884 310.624 128.884C311.884 128.861 313.147 128.746 314.412 128.549C314.886 130.503 314.506 133.615 313.183 133.826Z"
        fill="#C54527"
      />
      <path
        d="M317.042 123.193C316.302 123.639 315.336 123.791 314.104 123.473C313.157 123.234 312.048 122.715 310.756 121.836C310.756 121.836 309.735 123.064 309.653 125.316C306.949 122.981 306.292 120.645 308.586 119.785C307.644 115.689 309.653 114.829 313.009 114.627C316.37 114.42 317.147 117.863 319.155 117.781C319.277 119.617 318.757 122.177 317.042 123.193Z"
        fill="#262166"
      />
      <path
        d="M317.042 123.193C317.005 123.524 316.95 123.905 316.872 124.315C316.421 126.711 315.244 130.053 313.47 129.869C313.378 129.865 313.282 129.846 313.18 129.814C311.585 129.313 310.624 127.764 310.123 126.624C309.792 125.884 309.654 125.318 309.654 125.318C309.681 124.606 309.8 123.994 309.953 123.493C310.279 122.412 310.757 121.838 310.757 121.838C312.049 122.716 313.157 123.236 314.105 123.475C315.336 123.791 316.302 123.639 317.042 123.193Z"
        fill="url(#paint8_linear_2_31)"
      />
      <path
        d="M313.47 131.28C313.451 132.149 313.332 132.829 312.753 132.87C311.58 132.953 310.022 131.422 310.105 129.758C310.132 129.193 310.142 128.591 310.142 128.039C310.142 127.482 310.132 126.977 310.123 126.623C310.624 127.763 311.585 129.312 313.18 129.813C313.282 129.845 313.378 129.864 313.47 129.868C313.465 130.352 313.484 130.839 313.47 131.28Z"
        fill="url(#paint9_linear_2_31)"
      />
      <path
        d="M341.073 121.317C341.018 121.644 340.682 122.204 340.03 122.968C340.061 121.014 339.634 118.049 339.446 116.825C339.919 116.467 340.173 116.264 340.173 116.264C340.173 116.264 341.321 119.787 341.073 121.317Z"
        fill="#C54527"
      />
      <path
        d="M291.094 104.344C289.348 105.838 288.496 109.094 288.194 110.528C287.647 109.558 287.335 108.91 287.352 108.726C287.462 107.526 289.756 103.265 290.248 103.32C290.332 103.328 290.635 103.709 291.094 104.344Z"
        fill="#C54527"
      />
      <path
        d="M318.467 151.591C314.56 152.156 307.208 152.658 300.85 149.959C301.163 146.929 301.434 141.509 301.531 137.431C304.68 138.764 311.479 141.136 318.62 140.391C318.063 144.305 318.219 148.272 318.467 151.591Z"
        fill="#FCAF17"
      />
      <path
        opacity="0.25"
        d="M317.7 160.327C311.309 164.428 299.273 157.509 298.989 156.414C298.685 155.265 299.862 154.037 300.519 152.069C300.629 151.734 300.74 150.984 300.85 149.959C301.163 146.929 301.434 141.509 301.531 137.431C301.586 134.828 301.572 132.774 301.453 132.231C301.591 132.654 303.752 139.504 304.859 146.17C306.008 153.052 305.76 156.331 309.121 158.542C311.088 159.834 314.679 160.515 317.7 160.327Z"
        fill="#010101"
      />
      <path
        d="M332.305 179.245C332.305 182.086 322.034 197.828 319.907 201.059C319.663 201.432 319.525 201.639 319.525 201.639C319.525 201.639 318.201 201.487 317.111 201.119C316.353 200.856 315.705 200.498 315.705 200.002C315.705 199.9 315.724 199.744 315.756 199.537C316.119 197.344 318.376 189.409 321.273 178.918C319.747 177.061 309.04 169.958 309.04 169.958C309.04 169.958 309.035 169.967 309.03 169.985C308.566 171.056 293.703 205.426 292.015 208.631C291.955 208.746 291.913 208.819 291.886 208.852C291.123 209.836 287.955 209.942 287.735 207.868C287.735 207.864 287.735 207.864 287.735 207.859C286.825 199.171 294.318 172.964 297.808 161.375C298.433 159.297 298.929 157.688 299.228 156.736C300.975 158.446 311.77 164.133 317.701 160.327C317.995 160.138 318.276 159.927 318.543 159.692C318.754 159.504 318.864 159.081 318.901 158.456C319.011 158.575 319.127 158.704 319.241 158.842C323.377 163.572 332.305 176.509 332.305 179.245Z"
        fill="#9DC2E7"
      />
      <path
        d="M293.062 213.44C292.653 215.486 281.835 221.55 282.82 217.881C283.62 214.906 286.626 209.716 287.734 207.859C287.734 207.864 287.734 207.864 287.734 207.868C287.955 209.942 291.123 209.837 291.885 208.852C291.912 208.82 291.954 208.747 292.014 208.631C292.566 210.213 293.329 212.116 293.062 213.44Z"
        fill="#262166"
      />
      <path
        d="M323.46 211.637C322.637 212.047 311.989 207.95 312.233 206.557C312.481 205.164 315.754 199.537 315.754 199.537C315.722 199.744 315.703 199.9 315.703 200.002C315.703 201.201 319.523 201.639 319.523 201.639C319.523 201.639 319.661 201.432 319.905 201.059C320.38 205.312 324.228 211.252 323.46 211.637Z"
        fill="#262166"
      />
      <path
        opacity="0.25"
        d="M307.646 168.785C307.646 168.785 295.847 191.956 291.422 207.859"
        stroke="#010101"
        strokeWidth="0.4597"
        strokeMiterlimit="10"
      />
      <path
        opacity="0.25"
        d="M310.431 168.785C310.431 168.785 323.54 177.388 324.033 178.781C324.524 180.174 317.232 199.538 317.232 199.538"
        stroke="#010101"
        strokeWidth="0.4597"
        strokeMiterlimit="10"
      />
      <path
        opacity="0.25"
        d="M319.24 158.841C317.797 164.606 309.438 163.039 305.163 161.931C302.676 161.287 299.825 161.264 297.808 161.374C298.433 159.296 298.929 157.687 299.228 156.735C300.975 158.445 311.77 164.132 317.701 160.326C317.995 160.137 318.276 159.926 318.543 159.691C318.754 159.503 318.864 159.08 318.901 158.455C319.01 158.575 319.125 158.704 319.24 158.841Z"
        fill="#010101"
      />
      <path
        opacity="0.25"
        d="M317.111 201.12C316.353 200.857 315.705 200.499 315.705 200.003C315.705 199.901 315.724 199.745 315.756 199.538C316.119 197.345 318.376 189.41 321.273 178.919C319.747 177.062 309.04 169.959 309.04 169.959C309.04 169.959 309.913 167.012 310.897 166.792C311.88 166.576 323.241 176.35 324.496 178.373C325.603 180.15 317.866 194.66 317.111 201.12Z"
        fill="#010101"
      />
      <path
        opacity="0.25"
        d="M317.042 123.193C317.005 123.524 316.95 123.905 316.872 124.315C314.008 125.773 311.198 122.49 310.863 122.531C310.67 122.554 310.274 123.051 309.953 123.492C310.279 122.411 310.757 121.837 310.757 121.837C312.049 122.715 313.157 123.235 314.105 123.474C315.336 123.791 316.302 123.639 317.042 123.193Z"
        fill="#010101"
      />
      <path
        opacity="0.25"
        d="M313.47 131.28C311.58 130.82 310.536 128.926 310.142 128.039C310.142 127.482 310.132 126.977 310.123 126.623C310.624 127.763 311.585 129.312 313.18 129.813C313.282 129.845 313.378 129.864 313.47 129.868C313.465 130.352 313.484 130.839 313.47 131.28Z"
        fill="#010101"
      />
      <path
        opacity="0.25"
        d="M318.62 140.392C318.179 143.504 318.187 146.649 318.335 149.476C317.59 146.336 316.938 142.961 317.7 141.008C319.014 137.643 319.157 137.487 319.176 137.487C318.941 138.443 318.757 139.417 318.62 140.392Z"
        fill="#010101"
      />
      <path
        d="M259.55 138.623C263.08 138.623 265.941 135.762 265.941 132.232C265.941 128.702 263.08 125.841 259.55 125.841C256.02 125.841 253.159 128.702 253.159 132.232C253.159 135.762 256.02 138.623 259.55 138.623Z"
        fill="#F47920"
      />
      <path
        d="M481.91 219.839C485.44 219.839 488.301 216.978 488.301 213.448C488.301 209.918 485.44 207.057 481.91 207.057C478.38 207.057 475.519 209.918 475.519 213.448C475.519 216.978 478.38 219.839 481.91 219.839Z"
        fill="#6561AB"
      />
      <path
        d="M147.762 173.178C151.292 173.178 154.153 170.317 154.153 166.787C154.153 163.257 151.292 160.396 147.762 160.396C144.232 160.396 141.371 163.257 141.371 166.787C141.371 170.317 144.232 173.178 147.762 173.178Z"
        fill="#9DC2E7"
      />
      <path
        d="M253.16 368.621C256.69 368.621 259.551 365.76 259.551 362.23C259.551 358.7 256.69 355.839 253.16 355.839C249.63 355.839 246.769 358.7 246.769 362.23C246.769 365.76 249.63 368.621 253.16 368.621Z"
        fill="#F26647"
      />
      <path
        d="M445.376 153.935C446.737 153.935 447.841 152.831 447.841 151.47C447.841 150.109 446.737 149.005 445.376 149.005C444.015 149.005 442.911 150.109 442.911 151.47C442.911 152.831 444.015 153.935 445.376 153.935Z"
        fill="#F47920"
      />
      <path
        d="M257.085 192.318C258.446 192.318 259.55 191.214 259.55 189.853C259.55 188.492 258.446 187.388 257.085 187.388C255.724 187.388 254.62 188.492 254.62 189.853C254.62 191.214 255.724 192.318 257.085 192.318Z"
        fill="#9DC2E7"
      />
      <path
        d="M183.345 158.942C184.706 158.942 185.81 157.838 185.81 156.477C185.81 155.116 184.706 154.012 183.345 154.012C181.984 154.012 180.88 155.116 180.88 156.477C180.88 157.838 181.984 158.942 183.345 158.942Z"
        fill="#6561AB"
      />
      <path
        d="M117.974 87.8389C117.974 87.8389 115.41 101.518 129.187 114.72C142.963 127.922 174.723 122.126 187.802 129.656C200.881 137.186 231.979 148.406 246.769 140.731C213.998 131.404 216.302 117.925 204.526 105.329C192.751 92.7339 175.502 102.925 162.182 82.2569C148.862 61.5879 159.297 22.7129 131.337 12.0419C103.376 1.3709 70.331 -10.9881 69.65 17.6539C68.969 46.2959 116.694 70.8539 117.974 87.8389Z"
        fill="url(#paint10_linear_2_31)"
      />
      <path
        d="M516.823 21.3859C516.823 21.3859 506.972 11.5539 488.301 15.4869C469.629 19.4199 456.506 48.9159 442.912 55.4699C429.317 62.0249 402.516 81.3799 400.513 97.9209C426.696 76.1179 436.528 85.6219 453.57 82.9999C470.612 80.3779 471.923 60.3859 496.504 61.0419C521.084 61.6969 547.303 92.2389 571.883 75.1659C596.463 58.0929 625.304 37.7729 602.034 21.0589C578.764 4.34489 531.571 29.9069 516.823 21.3859Z"
        fill="url(#paint11_linear_2_31)"
      />
      <path
        d="M593.84 166.262C593.84 166.262 553.857 210.13 545.335 261.564C536.814 312.999 495.828 309.721 481.909 333.973C467.989 358.225 434.817 360.192 419.613 370.024C404.409 379.856 369.77 362.814 363.82 370.024C357.871 377.234 394.89 388.378 442.911 389.033C490.932 389.688 500.107 352.327 542.713 347.083C585.319 341.839 627.924 323.486 643 254.005C658.077 184.526 632.513 147.343 593.84 166.262Z"
        fill="url(#paint12_linear_2_31)"
      />
      <path
        d="M16.78 183.927C16.78 183.927 56.763 227.796 65.285 279.229C73.806 330.663 114.792 327.385 128.711 351.638C142.63 375.89 175.803 377.857 191.007 387.689C206.211 397.521 240.85 380.479 246.8 387.689C252.749 394.899 215.73 406.042 167.709 406.698C119.688 407.353 110.513 369.991 67.907 364.748C25.302 359.504 -17.305 341.151 -32.38 271.671C-47.457 202.191 -21.893 165.007 16.78 183.927Z"
        fill="url(#paint13_linear_2_31)"
      />
      <path
        d="M226.634 171.742L191.262 165.664L191.207 165.981L113.092 253.929L111.479 275.914L122.683 277.84L142.075 281.173L168.105 285.647L170.579 286.07L168.717 296.915L167.853 301.932L165.007 318.505L188.03 322.463L200.38 324.583L205.951 292.148L221.49 294.814L226.179 267.519L210.64 264.853L226.634 171.742ZM182.477 216.81L175.263 258.775L166.634 257.29L147.761 254.05L158.211 241.577L160.602 238.722L180.527 214.94L183.345 211.75L182.477 216.81Z"
        fill="#6561AB"
      />
      <path
        opacity="0.25"
        d="M168.105 285.647L142.075 281.173C145.141 271.045 148.967 257.087 147.762 254.049L166.635 257.289C167.844 259.304 168.8 262.075 169.058 265.878C169.517 272.609 168.514 279.482 168.105 285.647Z"
        fill="#010101"
      />
      <path
        d="M148.888 254.245C148.888 254.245 151.726 250.307 158.117 251.537C164.508 252.767 165 260.633 162.214 269.318C159.428 278.003 158.773 308.318 160.083 318.15C161.395 327.982 160.575 332.571 157.462 332.898C154.349 333.226 152.873 321.099 154.676 312.579C156.479 304.058 156.315 296.192 153.365 297.503C150.415 298.815 152.873 302.092 151.398 305.041C149.923 307.99 145.499 306.188 145.663 300.616C145.827 295.044 154.736 258.835 148.888 254.245Z"
        fill="#9DC2E7"
      />
      <path
        opacity="0.25"
        d="M210.64 264.853L226.179 267.519L221.49 294.814L205.951 292.148L200.379 324.583L188.03 322.462L209.735 187.033L226.634 171.742L210.64 264.853Z"
        fill="#010101"
      />
      <path
        d="M200.067 -30.3781V180.708"
        stroke="#0A2533"
        strokeWidth="0.9195"
        strokeMiterlimit="10"
      />
      <path
        d="M407.487 168.151C407.129 169.53 406.531 171.305 405.602 173.681C404.278 177.088 402.278 181.731 399.331 188.204C399.258 191.492 398.21 212.46 397.925 217.287C397.888 217.876 397.865 218.225 397.856 218.271C397.815 218.482 397.056 218.887 396.229 219.094C395.447 219.296 394.611 219.323 394.251 218.845C393.511 217.862 388.514 198.032 388.271 193.363C388.023 188.692 387.779 189.758 393.511 171.162C392.118 171.815 383.089 171.571 383.089 171.571C383.089 171.571 384.744 194.346 384.753 194.511C384.753 194.534 384.739 194.589 384.707 194.667C384.602 194.98 384.27 195.675 383.912 196.024C383.751 196.184 383.585 196.276 383.433 196.23C383.346 196.208 383.134 196.014 382.827 195.688C381.094 193.848 376.34 187.661 373.765 181.891C370.735 175.091 369.994 170.337 372.864 165.588C375.733 160.835 390.26 160.471 390.26 160.471C391.18 160.728 393.294 160.981 395.386 161.478C396.002 161.621 396.618 161.791 397.198 161.984C400.38 163.041 406.443 164.383 407.749 163.63C408.039 164.644 408.103 165.83 407.487 168.151Z"
        fill="#6561AB"
      />
      <path
        d="M419.528 152.318C418.953 152.644 412.278 152.396 407.767 150.676C407.79 151.471 407.891 152.722 408.006 154.143C408.186 156.382 408.393 159.044 408.342 160.984C408.314 162.368 408.154 163.388 407.767 163.623C407.762 163.628 407.758 163.632 407.748 163.632C407.055 164.032 405.022 163.839 402.788 163.416C401.344 163.14 399.818 162.768 398.517 162.395C398.043 162.257 397.598 162.12 397.198 161.986C394.642 161.131 391.452 160.804 390.26 160.473C389.961 160.39 389.791 160.312 389.781 160.22C389.745 159.769 390.889 158.749 391.427 157.682C391.491 157.549 391.578 157.351 391.675 157.098C392.112 155.981 392.797 153.866 393.128 152.519C393.325 151.724 393.399 151.2 393.225 151.291C392.692 151.576 389.537 157.475 389.169 157.475C389.041 157.475 388.406 157.112 387.652 156.601C386.383 155.741 384.788 154.477 384.751 153.875C384.742 153.792 384.765 153.723 384.825 153.668C385.565 152.969 391.215 143.466 393.265 141.439C394.226 140.482 395.362 139.908 396.286 139.568C397.32 139.182 398.102 139.094 398.102 139.094C399.32 139.052 400.547 139.214 401.743 139.517C405.807 140.533 409.536 143.099 411.66 144.367C414.404 146.004 416.289 145.554 416.983 145.963C417.684 146.378 420.097 151.987 419.528 152.318Z"
        fill="#F26647"
      />
      <path
        d="M408.342 160.984C404.563 161.03 396.163 160.694 391.676 157.099C392.113 155.982 392.798 153.867 393.129 152.52C393.129 152.52 401.997 155.209 408.006 154.143C408.186 156.382 408.393 159.044 408.342 160.984Z"
        fill="#F69181"
      />
      <path
        opacity="0.25"
        d="M401.745 139.519C401.599 141.091 401.042 142.783 399.331 142.65C396.918 142.462 396.398 140.489 396.288 139.57C397.322 139.184 398.104 139.096 398.104 139.096C399.322 139.054 400.549 139.215 401.745 139.519Z"
        fill="#010101"
      />
      <path
        d="M400.724 136.093C400.724 136.093 400.315 134.415 399.492 133.551C398.826 134.636 396.256 135.192 394.274 135.335C393.336 135.404 392.527 135.381 392.118 135.275C390.725 129.864 395.069 127.491 397.488 127.326C399.901 127.16 402.076 128.958 401.419 131.703C403.588 133.841 400.724 136.093 400.724 136.093Z"
        fill="#321212"
      />
      <path
        d="M400.724 136.093C400.6 136.452 400.407 137.082 400.076 137.67H400.071C399.529 138.649 398.619 139.518 397.042 138.879C396.987 138.856 396.932 138.833 396.881 138.806C395.553 138.203 394.863 137.031 394.514 136.107C394.404 135.817 394.326 135.551 394.275 135.335C396.256 135.192 398.827 134.636 399.493 133.551C399.53 133.593 399.567 133.634 399.603 133.675C400.352 134.567 400.724 136.093 400.724 136.093Z"
        fill="url(#paint14_linear_2_31)"
      />
      <path
        d="M400.517 140.272C400.274 141.789 397.773 141.707 397.501 140.723C397.358 140.213 397.197 139.721 397.073 139.362C396.963 139.027 396.88 138.81 396.88 138.81V138.806C396.931 138.833 396.986 138.856 397.041 138.879C398.618 139.518 399.528 138.65 400.07 137.67H400.075C399.905 138.01 400.36 138.438 400.512 139.242C400.568 139.532 400.582 139.873 400.517 140.272Z"
        fill="url(#paint15_linear_2_31)"
      />
      <path
        d="M387.53 200.329C387.286 202.214 377.535 209.588 377.701 208.278C377.861 206.967 382.827 195.69 382.827 195.69C383.135 196.016 383.347 196.21 383.433 196.232C383.925 196.375 384.55 195.124 384.706 194.669C386.017 196.315 387.75 198.646 387.53 200.329Z"
        fill="#262166"
      />
      <path
        d="M394.25 234.198C391.956 229.278 394.25 218.846 394.25 218.846C394.986 219.83 397.772 218.681 397.854 218.272C397.864 218.226 397.886 217.876 397.923 217.288C397.923 217.288 398.291 222.286 398.728 226.52C399.165 230.754 396.545 239.112 394.25 234.198Z"
        fill="#262166"
      />
      <path
        opacity="0.25"
        d="M393.51 171.163C392.117 171.816 383.088 171.572 383.088 171.572C383.088 171.572 384.743 194.347 384.752 194.512C384.752 194.535 384.738 194.59 384.706 194.668C384.601 194.981 384.269 195.676 383.911 196.025C382.247 188.232 378.928 173.29 381.575 170.725C384.964 167.447 394.14 166.574 394.273 167.291C394.407 168.013 393.51 171.163 393.51 171.163Z"
        fill="#010101"
      />
      <path
        d="M387.014 160.4C386.881 160.676 386.812 160.906 386.854 161.058C387.051 161.821 386.003 171.379 386.385 172.363C386.766 173.347 386.987 176.459 386.766 178.427C386.545 180.395 382.45 181.595 382.45 179.903C382.45 178.207 382.942 174.221 383.107 172.69C383.272 171.164 381.742 160.102 382.151 158.571C382.418 157.573 383.443 155.882 384.123 154.829C384.486 154.264 384.753 153.877 384.753 153.877C384.814 154.837 388.836 157.477 389.171 157.477C389.17 157.476 387.552 159.288 387.014 160.4Z"
        fill="url(#paint16_linear_2_31)"
      />
      <path
        opacity="0.25"
        d="M407.487 168.151C405.68 168.018 403.648 167.227 402.232 165.806C400.586 164.16 397.841 162.634 395.386 161.48C396.002 161.623 396.618 161.793 397.198 161.986C400.38 163.043 406.443 164.385 407.749 163.632C408.039 164.644 408.103 165.83 407.487 168.151Z"
        fill="#010101"
      />
      <path
        opacity="0.25"
        d="M405.602 173.682C404.278 177.089 402.278 181.732 399.331 188.205C399.258 191.493 398.21 212.461 397.925 217.288C397.888 217.877 397.865 218.226 397.856 218.272C397.815 218.483 397.056 218.888 396.229 219.095C396.417 212.024 396.169 196.632 397.365 192.053C398.793 186.573 405.202 174.436 405.602 173.682Z"
        fill="#010101"
      />
      <path
        opacity="0.25"
        d="M398.517 162.395C398.043 162.257 397.598 162.12 397.198 161.986C394.642 161.131 391.452 160.804 390.26 160.473C389.961 160.39 389.791 160.312 389.781 160.22C389.745 159.769 390.889 158.749 391.427 157.682C391.96 156.615 393.758 151.002 393.225 151.291C392.692 151.576 389.537 157.475 389.169 157.475C389.041 157.475 388.406 157.112 387.652 156.601C387.73 156.468 387.817 156.334 387.914 156.192C389.878 153.296 393.101 149.692 393.647 146.579C394.084 144.285 394.741 145.595 394.63 148.547C394.532 151.196 394.389 159.306 398.517 162.395Z"
        fill="#010101"
      />
      <path
        opacity="0.25"
        d="M407.767 163.623C407.762 163.628 407.758 163.632 407.748 163.632C407.055 164.032 405.022 163.839 402.788 163.416C406.783 159.412 404.603 148.566 405.229 149.123C405.964 149.776 407.766 150.677 407.766 150.677C407.85 153.628 409.041 162.846 407.767 163.623Z"
        fill="#010101"
      />
      <path
        opacity="0.25"
        d="M389.17 157.476C389.17 157.476 387.552 159.288 387.014 160.4C387 160.156 386.983 159.931 386.959 159.729C386.835 158.557 385.01 156.009 384.122 154.828C384.485 154.263 384.752 153.876 384.752 153.876C384.813 154.837 388.835 157.476 389.17 157.476Z"
        fill="#010101"
      />
      <path
        opacity="0.25"
        d="M399.602 133.675C398.619 135.85 395.727 136.102 394.513 136.107C394.403 135.817 394.325 135.551 394.274 135.335C396.255 135.192 398.826 134.636 399.492 133.551C399.529 133.593 399.566 133.634 399.602 133.675Z"
        fill="#010101"
      />
      <path
        opacity="0.25"
        d="M400.512 139.243C400.328 139.386 400.104 139.492 399.823 139.556C398.504 139.855 397.575 139.598 397.074 139.363C396.964 139.028 396.881 138.811 396.881 138.811V138.807C396.932 138.834 396.987 138.857 397.042 138.88C398.619 139.519 399.529 138.651 400.071 137.671H400.076C399.906 138.011 400.361 138.438 400.512 139.243Z"
        fill="#010101"
      />
      <path
        d="M413.586 -30.3781V173.682"
        stroke="#0A2533"
        strokeWidth="0.9195"
        strokeMiterlimit="10"
      />
      <path
        d="M422.189 149.394C422.18 149.449 422.167 149.504 422.157 149.555C421.615 152.024 419.638 152.286 419.265 152.125C418.893 151.964 417.909 150.833 417.049 146.848C417.03 146.769 417.017 146.691 416.998 146.609C416.998 146.609 415.141 141.846 414.268 139.556C412.112 138.278 411.703 138.798 411.399 137.322C411.1 135.846 412.057 133.938 412.604 133.662C413.151 133.391 415.606 135.685 415.937 136.531C416.263 137.376 422.681 146.773 422.189 149.394Z"
        fill="url(#paint17_linear_2_31)"
      />
      <path
        opacity="0.25"
        d="M422.157 149.555C421.615 152.024 419.638 152.286 419.265 152.125C418.893 151.964 417.909 150.833 417.049 146.848C417.596 147.955 418.438 149.39 419.362 149.983C420.377 150.63 421.518 150.424 422.157 149.555Z"
        fill="#010101"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_2_31"
        x1="406.622"
        y1="238.229"
        x2="414.487"
        y2="364.077"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCAF17" />
        <stop offset="1" stopColor="#F47920" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2_31"
        x1="108.641"
        y1="204.175"
        x2="109.542"
        y2="195.653"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FBC4AF" />
        <stop offset="1" stopColor="#EA8B69" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2_31"
        x1="119.998"
        y1="201.325"
        x2="112.132"
        y2="201.898"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FBC4AF" />
        <stop offset="1" stopColor="#EA8B69" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2_31"
        x1="109.701"
        y1="233.43"
        x2="116.911"
        y2="207.539"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FBC4AF" />
        <stop offset="1" stopColor="#EA8B69" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_2_31"
        x1="285.266"
        y1="99.9473"
        x2="288.135"
        y2="106.043"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FBC4AF" />
        <stop offset="1" stopColor="#EA8B69" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_2_31"
        x1="280.916"
        y1="99.7963"
        x2="288.044"
        y2="102.787"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FBC4AF" />
        <stop offset="1" stopColor="#EA8B69" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_2_31"
        x1="285.007"
        y1="97.5019"
        x2="289.596"
        y2="107.252"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FBC4AF" />
        <stop offset="1" stopColor="#EA8B69" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_2_31"
        x1="350.341"
        y1="107.151"
        x2="337.315"
        y2="122.636"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FBC4AF" />
        <stop offset="1" stopColor="#EA8B69" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_2_31"
        x1="313.907"
        y1="130.755"
        x2="312.514"
        y2="114.531"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FBC4AF" />
        <stop offset="1" stopColor="#EA8B69" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_2_31"
        x1="311.524"
        y1="130.881"
        x2="312.18"
        y2="126.702"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FBC4AF" />
        <stop offset="1" stopColor="#EA8B69" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_2_31"
        x1="114.18"
        y1="47.1314"
        x2="280.968"
        y2="200.72"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="#9DC2E7" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_2_31"
        x1="552.579"
        y1="41.2084"
        x2="331.685"
        y2="92.3353"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="#9DC2E7" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_2_31"
        x1="575.555"
        y1="264.908"
        x2="258.48"
        y2="338.296"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="#9DC2E7" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_2_31"
        x1="35.0649"
        y1="282.571"
        x2="352.141"
        y2="355.959"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="#9DC2E7" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_2_31"
        x1="397.377"
        y1="138.502"
        x2="397.705"
        y2="131.006"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FBC4AF" />
        <stop offset="1" stopColor="#EA8B69" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_2_31"
        x1="398.833"
        y1="141.691"
        x2="398.587"
        y2="136.366"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FBC4AF" />
        <stop offset="1" stopColor="#EA8B69" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_2_31"
        x1="382.396"
        y1="181.892"
        x2="388.295"
        y2="143.547"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FBC4AF" />
        <stop offset="1" stopColor="#EA8B69" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_2_31"
        x1="415.4"
        y1="135.642"
        x2="419.988"
        y2="159.839"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FBC4AF" />
        <stop offset="1" stopColor="#EA8B69" />
      </linearGradient>
      <clipPath id="clip0_2_31">
        <rect width="591.837" height="420.775" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default NotFound;
